import {
  dimensiondata_1_keszletek_group_row_w300,
  dimensiondata_2_termekek_group_1_2_3_column,
  kilo_tonna_value_1_data_precision1,
  year_column_expanded,
  month_column_expanded,
  order_1,
  order_2
} from '../../fields';
import { PivotGridConfig } from '../../utils/pivot-grid-config';

export const haviOlajKeszletConfig: PivotGridConfig = {
  showChart: false,
  treeHeaderLayout: false,
  filterYear: {},
  options: {
    store: {
      version: 4,
      type: 'odata',
      url: 'odata/v4/public/HaviOlajKeszlet',
      select: ['date', 'dimension_1', 'value_1'],
      beforeSend: (e: any) => {
        e.headers = {
          Accept: 'application/json;odata.metadata=none',
        };
      },
    },
    retrieveFields: false,
    fields: [
      ...dimensiondata_1_keszletek_group_row_w300,
      year_column_expanded,
      month_column_expanded,
      ...dimensiondata_2_termekek_group_1_2_3_column,
      kilo_tonna_value_1_data_precision1,
      order_1,
      order_2
    ],
  },
};
